import defaultAttributes from '../defaultAttributes';

const BluetoothOff = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M17 17l-5 5V12l-5 5' }],
    ['path', { d: 'M2 2l20 20' }],
    ['path', { d: 'M14.5 9.5L17 7l-5-5v4.5' }],
  ],
];

export default BluetoothOff;
